"use client";

import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";

import { cn } from "../../lib/utils";
import { SCROLL_AREA_STYLES } from "./constants";
import type {
  ScrollAreaProps,
  ScrollBarProps,
  ScrollAreaRef,
  ScrollBarRef,
} from "./types";

const ScrollArea = React.forwardRef<ScrollAreaRef, ScrollAreaProps>(
  ({ className, children, ...props }, ref) => (
    <ScrollAreaPrimitive.Root
      ref={ref}
      className={cn(SCROLL_AREA_STYLES.root, className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport className={SCROLL_AREA_STYLES.viewport}>
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  )
);
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

const ScrollBar = React.forwardRef<ScrollBarRef, ScrollBarProps>(
  ({ className, orientation = "vertical", ...props }, ref) => (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      ref={ref}
      orientation={orientation}
      className={cn(
        SCROLL_AREA_STYLES.scrollbar.base,
        orientation === "vertical" && SCROLL_AREA_STYLES.scrollbar.vertical,
        orientation === "horizontal" && SCROLL_AREA_STYLES.scrollbar.horizontal,
        className
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb
        className={SCROLL_AREA_STYLES.thumb}
      />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  )
);
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export { ScrollArea, ScrollBar };
